





































































import { categories, scrapers } from '../data';
import pako from 'pako';
import Stat from '@/components/Stat.vue';
import Diff from '@/components/Diff.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import IDetectionSession from '@double-agent/runner/interfaces/IDetectionSession';
import IFlaggedCheck from '@double-agent/runner/interfaces/IFlaggedCheck';
import { json } from '../../../../ulixee/shared/types';

@Component({
  components: {
    Stat,
    Diff,
  },
})
export default class ScraperBenchmark extends Vue {
  @Prop()
  private scraperKey!: string;
  @Prop()
  private browserKey!: string;

  private checksToLoad = 50;
  private botScore = 0;
  private categoryBotScores: { [category: string]: number } = {};
  private categoryCheckCounts: { [category: string]: number } = {};

  private get checks() {
    return Object.values(this.categoryCheckCounts).reduce((a, b) => a + b, 0);
  }

  private get flags() {
    return (this.session.flaggedChecks ?? []).length;
  }

  private get assetsNotLoadedTypes() {
    const types: string[] = [];
    for (const asset of this.session.assetsNotLoaded ?? []) {
      if (!types.includes(asset.resourceType.toString())) types.push(asset.resourceType.toString());
    }
    return types.join(', ');
  }

  private get notLoaded() {
    return (this.session.assetsNotLoaded ?? []).length;
  }

  private session: IDetectionSession = {} as IDetectionSession;

  private flagsByCategory: { [category: string]: IFlaggedCheck[] } = {};

  categoryFlags(category: string) {
    return this.flagsByCategory[category];
  }

  categoryBotScore(category: string) {
    return this.categoryBotScores[category] ?? 0;
  }

  categoryFlagCount(category: string) {
    return this.flagsByCategory[category]?.length ?? 0;
  }

  categoryChecks(category: string) {
    return this.categoryCheckCounts[category] ?? 0;
  }

  private categoryKeys = Object.keys(categories).filter(x => categories[x].implemented);
  private categories = categories;

  get scraper() {
    return scrapers[this.scraperKey].title;
  }

  get browser() {
    return this.titleCase(this.browserKey);
  }

  get browsers() {
    const findings = scrapers[this.scraperKey].browserFindings;
    return Object.keys(findings)
      .map(x => ({
        code: x,
        label: this.titleCase(x),
      }))
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
  }

  showFlagAsList(flag: IFlaggedCheck) {
    return (
      flag.category?.includes('Cookie') ||
      flag.category?.includes('Codecs') ||
      flag.checkName === 'Headers in Correct Order'
    );
  }
  async mounted() {
    this.loadBenchmarkData();
  }

  loadBenchmarkData() {
    this.$http
      .get(
        process.env.VUE_APP_DATA_HOST +
          `/scrapers/${this.scraperKey}/sessions/${this.browserKey}.json.gz`,
        { responseType: 'arraybuffer' },
      )
      .then(x => {
        const jsonBody = pako.ungzip((x as any).body, { to: 'string' });
        return JSON.parse(jsonBody);
      })
      .then((session: any) => {
        let botScore = 0;
        const flagsByCategory: { [category: string]: IFlaggedCheck[] } = {};
        const categoryChecks: { [category: string]: number } = {};
        const categoryBotScores: { [category: string]: number } = {};
        for (const flag of session.flaggedChecks ?? []) {
          const category = flag.category;
          if (!flagsByCategory[category]) {
            flagsByCategory[category] = [];
            categoryBotScores[category] = 0;
          }

          const flags = flagsByCategory[category];
          // too many to traverse
          if (category === 'Dom Features Match Version') {
            flags.push(flag);
          } else if (!flags.some(x => x.checkName === flag.checkName && x.value === flag.value)) {
            flags.push(flag);
          }
          if (flag.pctBot > botScore) {
            botScore = flag.pctBot;
          }
          if (flag.pctBot > categoryBotScores[category]) {
            categoryBotScores[category] = flag.pctBot;
          }
        }

        for (const check of session.checks) {
          if (!categoryChecks[check.category]) categoryChecks[check.category] = 0;
          categoryChecks[check.category] += check.count;
        }

        this.botScore = botScore;
        this.flagsByCategory = flagsByCategory;
        this.categoryCheckCounts = categoryChecks;
        this.categoryBotScores = categoryBotScores;
        this.session = session || {};

        const hash = document.location.hash;
        if (hash) {
          setTimeout(() => {
            const elem = document.querySelector(hash);
            if (elem) {
              elem.scrollIntoView({
                behavior: 'smooth',
              });
            }
          }, 100);
        }
      });
  }

  browserChanged(browserKey) {
    this.$router.push({
      name: 'scraperBenchmark',
      params: {
        scraperKey: this.scraperKey,
        browserKey,
      },
    });
    this.session = {} as IDetectionSession;
    this.loadBenchmarkData();
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  titleCase(str: string) {
    return str
      .split('__')
      .reverse()
      .map(this.capitalizeFirstLetter)
      .join(' on ')
      .replace(/_/g, ' ')
      .split(' ')
      .join(' ')
      .replace('Mac os x', 'Mac OS X')
      .replace(' 0 0', ' ')
      .replace(' 0', ' ')
      .replace(/(\d+)\s(\d+)/g, '$1.$2');
  }
}
